export const APPLICATION_NAME = 'Online Offer';
